import React from 'react';
import { useDispatch } from 'react-redux';
import { ButtonProps } from '@mui/material';
import { SnackbarKey } from 'notistack';

import { closeSnackbar } from '../store/notificationsSlice';
import { NotificationActionButton } from './NotificationActionButton';

export function SnackbarDismissButton({
  notificationKey,
  ...buttonProps
}: { notificationKey: SnackbarKey } & Partial<ButtonProps>) {
  const dispatch = useDispatch();

  return (
    <NotificationActionButton
      {...buttonProps}
      onClick={(event) => {
        dispatch(closeSnackbar(notificationKey));
        event.stopPropagation();
      }}
    >
      Dismiss
    </NotificationActionButton>
  );
}
